import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { AuthProvider } from './contexts/AuthContext';
import { ProtectedRoute, AdminRoute } from './components/ProtectedRoute';
import Navigation from './components/Navigation';
import Home from './pages/Home';
import Login from './pages/Login';
import AdminDashboard from './pages/AdminDashboard';
import UserDashboard from './pages/UserDashboard';
import PhoneNumberPage from './pages/PhoneNumberPage';
import PrivacyPage from './pages/PrivacyPage';
import TermsPage from './pages/TermsPage';
import LearnHub from './pages/learn/LearnHub';
import LearnArticlePage from './pages/learn/LearnArticlePage';
import LearnRegionsIndex from './pages/learn/LearnRegionsIndex';
import LearnRegionPage from './pages/learn/LearnRegionPage';

function App() {
  return (
    <AuthProvider>
      <Router>
        <Navigation />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/login" element={<Login />} />
          <Route path="/number/:number" element={<PhoneNumberPage />} />
          <Route path="/privacy" element={<PrivacyPage />} />
          <Route path="/terms" element={<TermsPage />} />
          <Route path="/learn" element={<LearnHub />} />
          <Route path="/learn/regions" element={<LearnRegionsIndex />} />
          <Route path="/learn/regions/:regionCode" element={<LearnRegionPage />} />
          <Route path="/learn/:slug" element={<LearnArticlePage />} />
          <Route
            path="/admin/*"
            element={
              <AdminRoute>
                <AdminDashboard />
              </AdminRoute>
            }
          />
          <Route
            path="/dashboard"
            element={
              <ProtectedRoute>
                <UserDashboard />
              </ProtectedRoute>
            }
          />
        </Routes>
      </Router>
    </AuthProvider>
  );
}

export default App;
